/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var DefaultPagesEnum;
(function (DefaultPagesEnum) {
    DefaultPagesEnum["DEFAULT_PAGE_400"] = "400";
    DefaultPagesEnum["DEFAULT_PAGE_401"] = "401";
    DefaultPagesEnum["DEFAULT_PAGE_403"] = "403";
    DefaultPagesEnum["DEFAULT_PAGE_404"] = "404";
    DefaultPagesEnum["DEFAULT_PAGE_ERROR"] = "error";
})(DefaultPagesEnum || (DefaultPagesEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1wYWdlcy5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9zaXRlL2RlZmF1bHQtcGFnZXMvZGVmYXVsdC1wYWdlcy5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksZ0JBTVg7QUFORCxXQUFZLGdCQUFnQjtJQUN4Qiw0Q0FBd0IsQ0FBQTtJQUN4Qiw0Q0FBd0IsQ0FBQTtJQUN4Qiw0Q0FBd0IsQ0FBQTtJQUN4Qiw0Q0FBd0IsQ0FBQTtJQUN4QixnREFBNEIsQ0FBQTtBQUNoQyxDQUFDLEVBTlcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQU0zQiJ9